<template>
    <div class="header" id="header">
        <Logo />
        <Navigation />
        <CommunityShorts />
    </div>
</template>

<script>
import Logo            from '@/components/layout/parts/Logo'
import Navigation      from '@/components/layout/parts/Navigation'
import CommunityShorts from '@/components/layout/parts/CommunityShorts'
export default {
    name: 'Header',
    components: { CommunityShorts, Navigation, Logo }
}
</script>